import React from 'react';
import classNames from 'classnames';
import { Radio as AntdRadio } from 'antd';
import { ConfigContext } from '../config-provider';
import RadioButton from './RadioButton';
import Group from './Group';
const InternalRadio = React.forwardRef((props, ref) => {
    // Translate new props size into classnames;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const { prefixCls: customizePrefixCls, className, ...restProps } = props;
    const prefixCls = getPrefixCls('radio', customizePrefixCls);
    const newClassName = classNames({
        [`${prefixCls}-wrapper-large`]: props.size === 'large',
        [`${prefixCls}-wrapper-small`]: props.size === 'small'
    }, className);
    return React.createElement(AntdRadio, { prefixCls: prefixCls, className: newClassName, ...restProps, ref: ref });
});
const Radio = InternalRadio;
Radio.displayName = AntdRadio.displayName;
Radio.defaultProps = AntdRadio.defaultProps;
Radio.Button = RadioButton;
Radio.Group = Group;
// export default withConfigProvider(Radio);
export default Radio;
